import { ColumnAlignment } from '@shared/utils/Table/TableColumn.interface';
export const ColumnAlignmentStyles = {
    [ColumnAlignment.Left]: 'align-left',
    [ColumnAlignment.Center]: 'align-center',
    [ColumnAlignment.Right]: 'align-right'
};
